import type { ApolloError } from '@apollo/client';
import { errorDictionary } from '@velove/graphql';

export interface HandleErrorOptions {
  /** Allows to override error messages if needed */
  dictionary?: Partial<typeof errorDictionary>;
}

/**
 * Parse an ApolloError, check for potentially known "errorKey" in the "extensions" payload, and returns customer-safe, known messages.
 */
export function retrieveErrorMessages(
  apolloError: ApolloError,
  options: HandleErrorOptions = {
    dictionary: errorDictionary
  }
): string[] {
  const errorMessages: string[] = [];
  const dictionary = {
    ...errorDictionary,
    ...options.dictionary
  };

  apolloError.graphQLErrors.forEach((error) => {
    const { errorKey } = error.extensions || {};

    if (typeof errorKey === 'string' && errorKey in dictionary) {
      errorMessages.push(dictionary[errorKey as keyof typeof dictionary]);
    }
  });

  return errorMessages.length > 0 ? errorMessages : ['Something went wrong...'];
}
